import { writable } from "svelte/store";

const hires = writable(false);

export { hires };
